import { useEffect, useState } from 'react';

/**
 * <img> that shows a "No image" placeholder instead of a broken-image icon
 * when `src` is empty or fails to load (404, network error, etc).
 */
export default function ImageWithFallback({ src, alt = '', className = '', fallbackClassName = '' }) {
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		setFailed(false);
	}, [src]);

	if (!src || failed) {
		return (
			<div
				className={`flex items-center justify-center bg-gray-100 text-gray-400 text-[9px] leading-tight text-center ${
					fallbackClassName || className
				}`}
			>
				No image
			</div>
		);
	}

	return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />;
}
